import React, { useEffect, useState } from 'react';
import { fetchLLRewards } from './loyaltyUtils';
import { LoadingMoreSpinner } from '../../../../../templates/product-listing-page/components/SmallUIComponents';
import { LLreward, LLrewardsResponse } from './loyaltyTypes';
import { RewardCard } from './RewardCard';
import { useMediaQuery } from '@material-ui/core';
import { useCartData } from '../../../../../utils/cart';
import { Customer } from '../../../../../utils/environment';
import { RewardVariantSelector } from './RewardVariantSelector';
import { loyaltyState } from './loyaltyState';
import { observer } from 'mobx-react-lite';

let RewardsCarousel = ({
  shouldHideRedeemButton = false,
  redeemButtonText,
  redeemAgainButtonText,
  alreadyRedeemedButtonText,
  redeemingButtonText,
}: {
  shouldHideRedeemButton?: boolean;
  redeemButtonText: string;
  redeemAgainButtonText: string;
  alreadyRedeemedButtonText: string;
  redeemingButtonText: string;
}) => {
  const [rewards, setRewards] = useState<LLreward[] | null>(null);
  const [isError, setIsError] = useState(false);
  const isDesktop = useMediaQuery('(min-width: 992px)', { noSsr: true });
  const isCustomer = !!Customer.id;
  const cartData = useCartData();
  const [isRedeeming, setIsRedeeming] = useState(false);

  const settings = {
    redeemButtonText,
    shouldHideRedeemButton,
    redeemAgainButtonText,
    alreadyRedeemedButtonText,
    redeemingButtonText,
  };

  useEffect(() => {
    const fetchRewards = async () => {
      const response = await fetchLLRewards(isCustomer);
      if (!response.hasOwnProperty('detail')) {
        setRewards((response as LLrewardsResponse).rewards);
      } else {
        console.error('Error fetching LL rewards', response);
        setIsError(true);
      }
    };
    fetchRewards();
  }, [isCustomer]);

  if (isError) {
    return null;
  } else if (!rewards) {
    return <LoadingMoreSpinner />;
  }
  if (!rewards && !isError) return null;

  return (
    <>
      <div id="LoyaltyLionCarousel" className={isDesktop ? 'desktop' : 'mobile'}>
        <div className="rewards-container">
          {rewards.map((reward) => (
            <RewardCard
              reward={reward}
              settings={settings}
              cartData={cartData}
              key={reward.id}
              isRedeeming={isRedeeming}
              setIsRedeeming={setIsRedeeming}
            />
          ))}
        </div>
      </div>
      {loyaltyState.variantSelectorData.reward && (
        <RewardVariantSelector reward={loyaltyState.variantSelectorData.reward} />
      )}
    </>
  );
};

RewardsCarousel = observer(RewardsCarousel);
export { RewardsCarousel };
